import { UNIT_TYPES, HEAT_SOURCE_UNIT_TYPES, REFRIGERANT_UNIT_TYPES } from "../../../../config/constants";
import {
  DEFAULT_HEAT_SOURCE,
  DEFAULT_REFIGERATION_SOURCE,
  DEFAULT_WATER_SOURCE
} from "../../../../config/drawingConstants";
import { SourceSectionConfig } from "../types/facilityDrawer.types";

export const EMPTY_VALUE = "—";
export const NO_RECORDS_LABEL = "No records added.";

export const DELETE_RECORD_CONFIRM_TITLE = "Delete Facility Energy";
export const DELETE_RECORD_CONFIRM_MESSAGE = "Are you sure you want to delete facility energy?";

export const ENERGY_DETAILS_COLUMNS = [
  { key: "source", header: "Source" },
  { key: "year", header: "Year" },
  { key: "kwh", header: "kWh consumed" },
  { key: "percentage", header: "Percentage" },
  { key: "price", header: "Price per kWh" }
];

export const VOLUME_DETAILS_COLUMNS = [
  { key: "source", header: "Source" },
  { key: "year", header: "Year" },
  { key: "volume", header: "Volume consumed" },
  { key: "price", header: "Price per unit" }
];

export const SOURCE_SECTION_CONFIGS: SourceSectionConfig[] = [
  {
    key: "heatSource",
    title: "Heat sources",
    sourceLabel: "Source",
    volumeLabel: "Volumes consumed",
    defaultSourceId: DEFAULT_HEAT_SOURCE,
    unitOptions: HEAT_SOURCE_UNIT_TYPES,
    defaultUnit: UNIT_TYPES[0].value
  },
  {
    key: "waterSource",
    title: "Water sources",
    sourceLabel: "Source",
    volumeLabel: "Volumes consumed",
    defaultSourceId: DEFAULT_WATER_SOURCE,
    unitOptions: null,
    defaultUnit: "",
    staticVolumeUnit: "m³"
  },
  {
    key: "refrigerantSource",
    title: "Refrigerant sources",
    sourceLabel: "Source",
    volumeLabel: "Volumes consumed",
    defaultSourceId: DEFAULT_REFIGERATION_SOURCE,
    unitOptions: REFRIGERANT_UNIT_TYPES,
    defaultUnit: UNIT_TYPES[0].value
  }
];
